// @vue/component

export default {
  data() {
    return {
      weekdays: ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"]
    };
  }
};
